







import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { LiteratureAdviceService } from '../../api/literatureAdvice';

@Component({})
export default class HotChapter extends Vue {
  @Prop() private literatureId?: string;
  private service: LiteratureAdviceService = new LiteratureAdviceService();
  private data: any[] = [];
  @Watch('literatureId')
  private literatureId_OnChange(val: any, oldVal: any) {
    this.loadData(val);
  }

  private mounted() {
    if (this.literatureId !== null && this.literatureId !== undefined && this.literatureId !== '') {
      this.loadData(this.literatureId);
    }
  }
  private loadData(id: string) {
    this.service.Search({literatureID: id}, 1).then((response: any) => {
      this.data = response;
    });
  }

}
